module.exports = __webpack_public_path__ + "static/media/pic_8_30.1c3802ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pic_8_30.jpg
// module id = 1841
// module chunks = 0 1